// Design tokens for the V2d driver tracking screen.
// Kept local to the track/ folder on purpose: the rest of the app uses
// Bootstrap classes + ad-hoc styling, and injecting a ThemeProvider here
// would risk cascading conflicts with existing `var(--bs-primary)` usage.

export const tokens = Object.freeze({
  colors: {
    violet: "#8B5CF6",
    violetDeep: "#6D28D9",
    violetInk: "#2E1065",
    page: "#EEECE6",
    surface: "#FFFFFF",
    surfaceAlt: "#F6F5F2",
    border: "rgba(20,14,30,0.08)",
    text: "#1C1B22",
    muted: "#6B6A73",
    subtle: "#9A99A3",
    danger: "#DC2626",
    dangerTint: "#FEF2F2",
    dangerBorder: "#FCA5A5",
    warn: "#D97706",
    warnTint: "#FFFBEB",
    warnBorder: "#FCD34D",
    warnInk: "#92400E",
    success: "#16A34A",
    successDot: "#A7F3D0",
    successHalo: "rgba(167,243,208,0.25)",
    errorBg: "#FEE2E2",
    errorInk: "#991B1B",
  },
  radii: { sm: 10, md: 14, lg: 22, pill: 999 },
  shadows: {
    card: "0 1px 0 rgba(20,14,30,0.04)",
    cta: "0 6px 18px rgba(139,92,246,0.4)",
  },
  spacings: { page: 14, gapCards: 10, gapChips: 8 },
  typo: { family: "-apple-system, system-ui, sans-serif" },
});
